
import { MobileNavigation } from "./navigation/MobileNavigation";
import { DesktopNavigation } from "./navigation/DesktopNavigation";

const Navigation = () => {
  return (
    <>
      <MobileNavigation />
      <div className="md:hidden h-6"></div>
      <DesktopNavigation />
    </>
  );
};

export default Navigation;
